import React from 'react'

const useTimer = (durationInMs, options = {}, callBack) => {
  const { shouldStartOnMount = false, shouldAutoReset = false, stepMs = 1000 } = options
  const [timeLeft, setTimeLeft] = React.useState(durationInMs)
  const [isRunning, setRunning] = React.useState(false)

  React.useEffect(() => {
    const countTimeLeft = () => {
      setTimeLeft(timeLeft => (timeLeft > stepMs ? timeLeft - stepMs : 0))
    }

    let timeLeftInterval
    if (isRunning === true) {
      timeLeftInterval = setInterval(countTimeLeft, stepMs)
    }
    return () => clearInterval(timeLeftInterval)
  }, [isRunning, stepMs])

  React.useEffect(() => {
    if (timeLeft === 0) {
      setRunning(false)
      typeof callBack === 'function' && callBack()
      shouldAutoReset && setTimeLeft(durationInMs)
    }
  }, [timeLeft, shouldAutoReset, durationInMs, callBack])

  React.useEffect(() => {
    if (shouldStartOnMount) {
      setRunning(true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const start = () => {
    if (isRunning === true || timeLeft === 0) return
    setRunning(true)
  }

  const pause = () => {
    if (isRunning === false) return
    setRunning(false)
  }

  const reset = () => {
    setTimeLeft(durationInMs)
    setRunning(false)
  }

  const stop = () => {
    setTimeLeft(0)
    setRunning(false)
  }

  return {
    isRunning,
    timeLeft,
    start,
    pause,
    stop,
    reset,
    setTimeLeft
  }
}

export default useTimer
